import { render } from "./removeUserPopup.vue?vue&type=template&id=0f0aa145&scoped=true"
import script from "./removeUserPopup.vue?vue&type=script&lang=js"
export * from "./removeUserPopup.vue?vue&type=script&lang=js"

import "./removeUserPopup.vue?vue&type=style&index=0&id=0f0aa145&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0aa145"]])

export default __exports__